export default __webpack_public_path__ + "static/media/Leona 9781408303542.8cfa730f.jpg";